import { render } from "./Chat.vue?vue&type=template&id=239a5d18&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=239a5d18&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-239a5d18"

export default script